export const CHANNEL_NAME = 'enclave';
export const INDEXED_DB_NAME = 'enclave';
